var hasKeyInDataset = function (dataset, key) {
    return Boolean(key) && dataset.some(function (item) { return item[key] !== undefined; });
};
export var getChartDataset = function (data) { var _a; return ((_a = data.dataset) !== null && _a !== void 0 ? _a : []).filter(function (item) { return item != null; }); };
export var parseNumericValue = function (rawValue) {
    if (typeof rawValue === "number")
        return rawValue;
    if (typeof rawValue === "string")
        return Number(rawValue.replace(",", "."));
    if ((rawValue === null || rawValue === void 0 ? void 0 : rawValue.parsedValue) !== undefined)
        return Number(rawValue.parsedValue);
    if ((rawValue === null || rawValue === void 0 ? void 0 : rawValue.value) !== undefined)
        return Number(rawValue.value);
    return 0;
};
var NUMBER_FORMATTER = new Intl.NumberFormat("pt-BR");
export var formatNumericValue = function (rawValue, options) {
    var parsed = typeof rawValue === "number" ? rawValue : parseNumericValue(rawValue);
    if (!Number.isFinite(parsed))
        return "—";
    if (!options)
        return NUMBER_FORMATTER.format(parsed);
    return new Intl.NumberFormat("pt-BR", options).format(parsed);
};
export var formatPercentValue = function (rawValue, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 2; }
    var parsed = typeof rawValue === "number" ? rawValue : parseNumericValue(rawValue);
    if (!Number.isFinite(parsed))
        return "—";
    return (formatNumericValue(parsed, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    }) + "%");
};
export var resolveMultiSeriesKeys = function (data, dataset) {
    var _a, _b;
    if (dataset === void 0) { dataset = getChartDataset(data); }
    var columns = (_a = data.columns) !== null && _a !== void 0 ? _a : [];
    if (columns.length < 2 || dataset.length === 0)
        return null;
    var isNonNumeric = function (type) {
        return type === "ordinal" || type === "categorical";
    };
    if (!isNonNumeric(columns[0].type) || !isNonNumeric(columns[1].type))
        return null;
    var declaredNumericColumn = columns.find(function (column, index) { return index >= 2 && column.type === "numeric"; });
    if (declaredNumericColumn &&
        hasKeyInDataset(dataset, declaredNumericColumn.name)) {
        return {
            xKey: columns[0].name,
            seriesKey: columns[1].name,
            valueKey: declaredNumericColumn.name,
        };
    }
    if (data.value_columns && hasKeyInDataset(dataset, data.value_columns)) {
        return {
            xKey: columns[0].name,
            seriesKey: columns[1].name,
            valueKey: data.value_columns,
        };
    }
    var colNames = new Set(columns.map(function (c) { return c.name; }));
    var sampleKeys = Object.keys((_b = dataset[0]) !== null && _b !== void 0 ? _b : {});
    var valueKey = sampleKeys.find(function (k) { return !colNames.has(k); });
    if (!valueKey)
        return null;
    return { xKey: columns[0].name, seriesKey: columns[1].name, valueKey: valueKey };
};
export var LINE_CHART_SMOOTH_INTENSITY = 0.4;
export var isMultiSeriesChart = function (data, chartType) {
    var effectiveType = chartType !== null && chartType !== void 0 ? chartType : data.chart;
    if (effectiveType !== "line" && effectiveType !== "bar")
        return false;
    return resolveMultiSeriesKeys(data, getChartDataset(data)) !== null;
};
export var resolveLabelAndValueKeys = function (data, dataset) {
    var _a, _b, _c, _d, _e, _f;
    if (dataset === void 0) { dataset = getChartDataset(data); }
    var columns = (_a = data.columns) !== null && _a !== void 0 ? _a : [];
    var datasetKeys = Object.keys((_b = dataset[0]) !== null && _b !== void 0 ? _b : {});
    var labelColumnKey = (_c = columns[0]) === null || _c === void 0 ? void 0 : _c.name;
    var valueColumnKey = (_d = columns[1]) === null || _d === void 0 ? void 0 : _d.name;
    var candidateValueKey = data.value_columns;
    var preferredValueKeys = [
        candidateValueKey,
        valueColumnKey,
        "value",
    ].filter(function (key) { return Boolean(key); });
    var valueKeyFromDataset = preferredValueKeys.find(function (key) {
        return hasKeyInDataset(dataset, key);
    });
    var valueKey = valueKeyFromDataset ||
        datasetKeys.find(function (key) { return key !== labelColumnKey; }) ||
        ((_e = columns.find(function (c) { return c.name !== labelColumnKey; })) === null || _e === void 0 ? void 0 : _e.name) ||
        datasetKeys[0] ||
        "value";
    var labelKeyFromDataset = labelColumnKey && hasKeyInDataset(dataset, labelColumnKey)
        ? labelColumnKey
        : undefined;
    var labelKey = labelKeyFromDataset ||
        datasetKeys.find(function (key) { return key !== valueKey; }) ||
        ((_f = columns.find(function (c) { return c.name !== valueKey; })) === null || _f === void 0 ? void 0 : _f.name) ||
        datasetKeys[0] ||
        "label";
    return { labelKey: labelKey, valueKey: valueKey };
};
